import type { SubmitContestRequestBody } from "../../hooks/loyalty/useSubmitContest";

export type ContestEntry = {
  question: string;
  answers: string[];
};

export const isContestEntry = (value: unknown): value is ContestEntry => {
  if (typeof value !== "object" || value === null) return false;

  const { question, answers } = value as Record<string, unknown>;

  if (typeof question !== "string") return false;
  if (!Array.isArray(answers)) return false;
  if (!answers.every((a) => typeof a === "string")) return false;
  if (answers.every((a) => a.trim() === "")) return false;

  return true;
};

export const buildContestPayload = (formData: Record<string, any>): SubmitContestRequestBody => {
  const contest = Object.entries(formData)
    .map(([_, value]) => value)
    .filter(isContestEntry);

  return {
    contest,
    files: formData.files || [],
    contest_id: formData.contest_id,
  };
};
